/**
 * Вертикальная гистограмма: часы суток, дни недели, счётчики по людям.
 *
 * Вынесена из AdminAnalyticsPage. Анимация высоты идёт через токен
 * длительности, поэтому при prefers-reduced-motion столбцы просто
 * появляются на своих местах.
 */
import { Vars } from '../Vars'

export function BarChart({
  values,
  labels,
  color = 'var(--accent)',
  height = 100,
  label = 'Гистограмма',
  formatValue = (v) => v,
}) {
  if (!values?.length) return null

  const maxV = Math.max(...values, 1)
  const peak = values.indexOf(maxV)

  return (
    <Vars
      as="div"
      className="bar-chart"
      vars={{ '--chart-h': `${height}px` }}
      role="img"
      aria-label={`${label}: максимум ${formatValue(maxV)} — ${labels?.[peak] ?? ''}`}
    >
      {values.map((v, i) => (
        <div key={i} className="bar-chart__col">
          <Vars
            as="div"
            className="bar-chart__bar"
            title={`${labels?.[i] ?? i}: ${formatValue(v)}`}
            vars={{
              '--bar-h': `${Math.max(2, (v / maxV) * 80)}%`,
              '--bar-color': v === 0 ? 'var(--border)' : color,
              '--bar-opacity': v === 0 ? 0.4 : 1,
            }}
          />
          {labels ? <span className="bar-chart__label">{labels[i]}</span> : null}
        </div>
      ))}
    </Vars>
  )
}
